.ju{bottom:0.25rem;}